import React from 'react';
import { 
  Card, 
  CompactCard, 
  Button, 
  FilterPanel 
} from '../../../components/common';
import SearchHotkeys from './SearchHotkeys';

const StudentListHeader = React.memo(({
  isStudentSelected,
  selectedStudent,
  studentsDataLength,
  totalItems,
  filters,
  teachers,
  isTeachersLoading,
  selectedHotkey,
  onStudentDetailClick,
  onSelectedStudentCardClick,
  onFilterChange,
  onFilterKeyPress,
  onSearch,
  onReset,
  onHotkeySelect,
  isMobile = false,
  userType = null
}) => {
  return (
    <div className={`${isMobile ? 'shrink-0 bg-white border-b' : 'bg-white p-4 border-b'}`}>
      {!isStudentSelected ? (
        <div className={isMobile ? 'p-4' : ''}>
          <div className="flex items-center gap-3">
            <h3 className="text-lg font-semibold">
              학생 목록
            </h3>
            <p className="text-xs text-gray-500">
              - 총 <span className="font-semibold text-primary">{totalItems || 0}</span>명 중 <span className="font-semibold text-primary">{studentsDataLength || 0}</span>명 표시 중
            </p>
          </div>
          
          {/* 필터 입력 필드들 */}
          {isMobile ? (
            <div>
              <div className="mt-3 flex gap-2">
                <div className={`flex-1 grid gap-2 ${userType === 'teacher' ? 'grid-cols-1' : 'grid-cols-2'}`}>
                  <input
                    type="text"
                    name="student_name"
                    placeholder="학생 이름"
                    value={filters.student_name}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className={`w-full rounded border px-2 py-1 text-xs ${
                      userType === 'teacher' ? 'col-span-1' : ''
                    }`}
                  />
                  {userType !== 'teacher' && (
                    <select
                      name="in_charge_teacher"
                      value={filters.in_charge_teacher}
                      onChange={onFilterChange}
                      className="w-full rounded border px-2 py-1 text-xs bg-white"
                      disabled={isTeachersLoading}
                    >
                      <option value="">
                        {isTeachersLoading ? '강사 목록 로딩중...' : '담당 강사'}
                      </option>
                      {teachers.map((teacher) => (
                        <option key={teacher.user_id} value={teacher.user_name}>
                          {teacher.user_name} ({teacher.charge_work})
                        </option>
                      ))}
                    </select>
                  )}
                  <input
                    type="text"
                    name="school_name"
                    placeholder="학교 이름"
                    value={filters.school_name}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className="w-full rounded border px-2 py-1 text-xs"
                  />
                  <input
                    type="text"
                    name="lecture"
                    placeholder="강의"
                    value={filters.lecture}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className="w-full rounded border px-2 py-1 text-xs"
                  />
                </div>
                <div className="flex w-16 flex-col gap-2">
                  <Button
                    onClick={onReset}
                    variant="secondary"
                    size="sm"
                    rounded="3xl"
                    className="flex-1 min-h-[22px]"
                  >
                    초기화
                  </Button>
                  <Button
                    onClick={onSearch}
                    variant="primary"
                    size="sm"
                    rounded="3xl"
                    className="flex-1 min-h-[22px]"
                  >
                    조회
                  </Button>
                </div>
              </div>
              
              {/* 검색 핫키 버튼들 - 강사는 제외 */}
              {userType !== 'teacher' && (
                <SearchHotkeys
                  selectedHotkey={selectedHotkey}
                  onHotkeySelect={onHotkeySelect}
                  disabled={false}
                />
              )}
            </div>
          ) : (
            <div>
              <div className="mt-3 flex gap-2">
                <div className={`flex-1 grid gap-2 ${userType === 'teacher' ? 'grid-cols-1' : 'grid-cols-2'}`}>
                  <input
                    type="text"
                    name="student_name"
                    placeholder="학생 이름"
                    value={filters.student_name}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className={`w-full rounded border px-2 py-1 text-xs ${
                      userType === 'teacher' ? 'col-span-1' : ''
                    }`}
                  />
                  {userType !== 'teacher' && (
                    <select
                      name="in_charge_teacher"
                      value={filters.in_charge_teacher}
                      onChange={onFilterChange}
                      className="w-full rounded border px-2 py-1 text-xs bg-white"
                      disabled={isTeachersLoading}
                    >
                      <option value="">
                        {isTeachersLoading ? '강사 목록 로딩중...' : '담당 강사'}
                      </option>
                      {teachers.map((teacher) => (
                        <option key={teacher.user_id} value={teacher.user_name}>
                          {teacher.user_name} ({teacher.charge_work})
                        </option>
                      ))}
                    </select>
                  )}
                  <input
                    type="text"
                    name="school_name"
                    placeholder="학교 이름"
                    value={filters.school_name}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className="w-full rounded border px-2 py-1 text-xs"
                  />
                  <input
                    type="text"
                    name="lecture"
                    placeholder="강의"
                    value={filters.lecture}
                    onChange={onFilterChange}
                    onKeyDown={onFilterKeyPress}
                    className="w-full rounded border px-2 py-1 text-xs"
                  />
                </div>
                <div className="flex w-16 flex-col gap-2">
                  <Button
                    onClick={onReset}
                    variant="secondary"
                    size="sm"
                    rounded="3xl"
                    className="flex-1 min-h-[22px]"
                  >
                    초기화
                  </Button>
                  <Button
                    onClick={onSearch}
                    variant="primary"
                    size="sm"
                    rounded="3xl"
                    className="flex-1 min-h-[22px]"
                  >
                    조회
                  </Button>
                </div>
              </div>
              
              {/* 검색 핫키 버튼들 - 강사는 제외 */}
              {userType !== 'teacher' && (
                <SearchHotkeys
                  selectedHotkey={selectedHotkey}
                  onHotkeySelect={onHotkeySelect}
                  disabled={false}
                />
              )}
            </div>
          )}
        </div>
      ) : selectedStudent && (
        isMobile ? (
          <div className="shrink-0 border-b bg-white">
            <Card padding="sm">
              <div 
                className="relative cursor-pointer rounded border-l-4 border-primary bg-gray-50 p-2 transition-colors hover:bg-gray-100"
                onClick={onSelectedStudentCardClick}
              >
              <div className="grid grid-cols-[1fr_140px] items-center">
                <div className="flex min-w-0 items-center gap-2">
                  {/* 좌측 학생 ID 배지 */}
                  <div 
                    className="flex shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-primary to-primary/70 text-sm font-bold text-white"
                    style={{ width: '32px', height: '32px' }}
                    title={`학생 ID: ${selectedStudent.student_id}`}
                  >
                    {selectedStudent.student_id}
                  </div>
                  
                  {/* 학생 정보 */}
                  <div className="min-w-0 overflow-hidden">
                    <h4 className="truncate text-sm font-medium text-gray-900">{selectedStudent.student_name}</h4>
                    <p className="truncate text-xs text-gray-600">{selectedStudent.school_name} · {selectedStudent.school_grade}학년</p>
                  </div>
                </div>
                
                {/* 담당 강사 & 강의반 정보 */}
                <div className="flex items-center">
                  <div className="flex flex-1 flex-col justify-center text-right">
                    {(selectedStudent.teacher_name || selectedStudent.in_charge_teacher || selectedStudent.lecture) ? (
                      <>
                        {(selectedStudent.teacher_name || selectedStudent.in_charge_teacher) && (
                          <div className="flex items-center justify-end text-xs">
                            <span className="shrink-0 text-gray-500">담당:</span>
                            <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                              {selectedStudent.teacher_name || selectedStudent.in_charge_teacher}
                            </span>
                          </div>
                        )}
                        {selectedStudent.lecture && (
                          <div className="mt-0.5 flex items-center justify-end text-xs">
                            <span className="shrink-0 text-gray-500">강의:</span>
                            <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                              {selectedStudent.lecture}
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-xs text-gray-400">-</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="absolute inset-x-0 top-1/2 flex -translate-y-1/2 items-center justify-center gap-1 text-xs text-primary">
                <span>←</span>
                <span>학생 목록으로</span>
              </div>
            </div>
            </Card>
          </div>
        ) : (
          <div className="shrink-0 border-b bg-white">
            <Card padding="sm">
              <div 
                className="relative cursor-pointer rounded border-l-4 border-primary bg-gray-50 p-2 transition-colors hover:bg-gray-100"
                onClick={onSelectedStudentCardClick}
              >
            <div className="grid grid-cols-[6fr_4fr_44px] items-center">
              <div className="flex min-w-0 items-center gap-2 pr-2">
                {/* 좌측 학생 ID 배지 */}
                <div 
                  className="flex shrink-0 items-center justify-center rounded bg-green-100 text-xs font-bold text-green-800"
                  style={{ width: '32px', height: '32px' }}
                  title={`학생 ID: ${selectedStudent.student_id}`}
                >
                  {selectedStudent.student_id}
                </div>
                
                {/* 학생 정보 */}
                <div className="min-w-0 flex-1 overflow-hidden">
                  <h4 className="truncate text-sm font-medium text-gray-900">{selectedStudent.student_name}</h4>
                  <p className="truncate text-xs text-gray-600">{selectedStudent.school_name} · {selectedStudent.school_grade}학년</p>
                  <p className="truncate text-xs text-gray-500">{selectedStudent.student_email}</p>
                </div>
              </div>
              
              {/* 중앙 영역 - 담당 강사 & 강의반 정보 */}
              <div className="flex items-center">
                <div className="flex flex-1 flex-col justify-center text-right">
                  {(selectedStudent.teacher_name || selectedStudent.in_charge_teacher || selectedStudent.lecture) ? (
                    <>
                      {(selectedStudent.teacher_name || selectedStudent.in_charge_teacher) && (
                        <div className="flex items-center justify-end text-xs">
                          <span className="shrink-0 text-gray-500">담당:</span>
                          <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                            {selectedStudent.teacher_name || selectedStudent.in_charge_teacher}
                          </span>
                        </div>
                      )}
                      {selectedStudent.lecture && (
                        <div className="mt-0.5 flex items-center justify-end text-xs">
                          <span className="shrink-0 text-gray-500">강의:</span>
                          <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                            {selectedStudent.lecture}
                          </span>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-xs text-gray-400">-</div>
                  )}
                </div>
              </div>
            </div>
            <div className="absolute inset-x-0 top-1/2 flex -translate-y-1/2 items-center justify-center gap-1 text-xs text-primary">
              <span>←</span>
              <span>학생 목록으로</span>
            </div>
          </div>
            </Card>
          </div>
        )
      )}
    </div>
  );
}, (prevProps, nextProps) => {
  // 원시값 비교
  if (
    prevProps.isStudentSelected !== nextProps.isStudentSelected ||
    prevProps.studentsDataLength !== nextProps.studentsDataLength ||
    prevProps.isTeachersLoading !== nextProps.isTeachersLoading ||
    prevProps.selectedHotkey !== nextProps.selectedHotkey ||
    prevProps.isMobile !== nextProps.isMobile ||
    prevProps.userType !== nextProps.userType
  ) {
    return false;
  }
  
  // selectedStudent 객체 비교 (주요 필드만)
  if (prevProps.selectedStudent !== nextProps.selectedStudent) {
    if (!prevProps.selectedStudent && !nextProps.selectedStudent) {
      // 둘 다 null/undefined인 경우 같음
    } else if (!prevProps.selectedStudent || !nextProps.selectedStudent) {
      return false; // 하나만 null인 경우 다름
    } else if (
      prevProps.selectedStudent.student_id !== nextProps.selectedStudent.student_id ||
      prevProps.selectedStudent.student_name !== nextProps.selectedStudent.student_name
    ) {
      return false;
    }
  }
  
  // filters 객체 비교
  const prevFilters = prevProps.filters || {};
  const nextFilters = nextProps.filters || {};
  if (
    prevFilters.student_name !== nextFilters.student_name ||
    prevFilters.in_charge_teacher !== nextFilters.in_charge_teacher ||
    prevFilters.lecture !== nextFilters.lecture ||
    prevFilters.school_name !== nextFilters.school_name
  ) {
    return false;
  }
  
  // teachers 배열 비교 (길이만 비교)
  const prevTeachers = prevProps.teachers || [];
  const nextTeachers = nextProps.teachers || [];
  if (prevTeachers.length !== nextTeachers.length) {
    return false;
  }
  
  // 모든 비교 통과 시 리렌더링 방지
  return true;
});

StudentListHeader.displayName = 'StudentListHeader';

export default StudentListHeader; 